<template>
  <div class="container-fluid">
    <v-toolbar dense
               src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg"
    >
    </v-toolbar>
    <v-container>
      <v-row>
        <v-col>
          <v-card>
            <v-card-title>
              Přiřazené jídelníčky
              <v-spacer></v-spacer>
              <v-select
                v-model="dietsToAdd"
                append-icon=""
                label="Přidat jídelníčky"
                single-line
                hide-details
                hide-selected
                :items="availableDiets"
                item-text="name"
                return-object
                multiple
                small-chips
                deletable-chips
              ></v-select>
              <v-icon
                color="success"
                @click="addDiets"
                v-show="dietsToAdd.length"
              >
                mdi-check
              </v-icon>
            </v-card-title>
            <v-data-table
              :headers="dietHeaders"
              :items="diets"
              :search="search"
            >
              <template v-slot:item.actions="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  @click="removeDiet(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
      <v-checkbox v-model="activeOwnerSwitch" :label="`Aktivní Vlastník`"></v-checkbox>
      <v-row>
        <v-col cols="6">
          <v-card
            v-if="activeOwnerSwitch"
          >
            <v-card-title>Vlastník instituce<v-spacer></v-spacer>
              <v-select
                v-model="owner"
                label="Vlastník instituce"
                append-icon=""
                single-line
                hide-details
                item-text="fullName"
                return-object
                :items="availableUsersAll"
                deletable-chips
                small-chips
              ></v-select>
              <v-icon
                color="success"
                @click="changeOwner(!!owner)"
              >
                mdi-check
              </v-icon>
            </v-card-title>
          </v-card>
          <v-card v-else>
            <v-card-title>
              Uživatelé
              <v-spacer></v-spacer>
              <v-autocomplete
                v-model="usersToAdd"
                label="Přidat uživatele"
                :items="availableUsers"
                item-value="id"
                item-text="fullName"
                multiple
                chips
                hide-selected
                small-chips
                deletable-chips
                append-icon=""
              ></v-autocomplete>
              <v-icon
                color="success"
                @click="addUsers"
                v-show="usersToAdd.length"
              >
                mdi-check
              </v-icon>
            </v-card-title>
            <v-data-table
              :headers="userHeaders"
              :items="users"
              :search="userSearch"
            >
              <template v-slot:item.actions="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  @click="deleteUser(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
        <v-col>
          <v-card>
            <v-card-title>
              <v-container>
                <v-row>
                  <v-col cols="3">
                    Strávníci
                  </v-col>
                  <v-col cols="8">
                    <v-text-field
                      v-model="boarderSearch"
                      append-icon="mdi-magnify"
                      label="Vyhledat strávníka"
                      single-line
                      hide-details
                      multiple
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="3"></v-col>
                  <v-col cols="8">
                    <v-select
                      v-model="boardersToAdd"
                      label="Přidat strávníka"
                      single-line
                      :items="availableBoarders"
                      item-value="id"
                      item-text="selectInputText"
                      multiple
                      chips
                      hide-selected
                      small-chips
                      deletable-chips
                      append-icon=""
                    ></v-select>
                  </v-col>
                  <v-col cols="1">
                    <v-icon
                      color="success"
                      @click="addUsers(false)"
                      v-show="boardersToAdd.length"
                    >
                      mdi-check
                    </v-icon>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-title>
            <v-data-table
              :headers="boarderHeaders"
              :items="boarders"
              :search="boarderSearch"
              item-key="id"
            >
              <template v-slot:item.actions="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  @click="deleteUser(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'InstitutionSettings',
  data () {
    return {
      institution: {},
      search: '',
      dietsToAdd: [],
      availableDiets: [],
      availableUsers: [],
      availableUsersAll: [],
      availableBoarders: [],
      availableBoardersAll: [],
      diets: [],
      dietHeaders: [
        {
          text: 'Název',
          align: 'start',
          sortable: false,
          value: 'name'
        },
        { text: 'Typ', value: 'foodTypesStr' },
        { text: 'Akce', value: 'actions', sortable: false }
      ],
      boarders: [],
      boarderHeaders: [
        {
          text: 'Jméno a Příjmení',
          align: 'start',
          sortable: false,
          value: 'fullName'
        },
        { text: 'Nadřazený uživatel', value: 'userName' },
        { text: 'Aktivní strávník', value: 'loggable' },
        {
          text: 'Akce',
          value: 'actions',
          sortable: false
        }
      ],
      users: [],
      userHeaders: [
        {
          text: 'Jméno a Příjmení',
          align: 'start',
          sortable: false,
          value: 'fullName'
        },
        {
          text: 'Akce',
          value: 'actions',
          sortable: false
        }
      ],
      activeOwnerSwitch: false,
      usersToAdd: [],
      boardersToAdd: [],
      owner: null,
      userSearch: null,
      boarderSearch: null
    }
  },
  methods: {
    initialize () {
      this.ownerToAdd = null
      this.$http.get(`/admin/institutions/${this.$route.params.id}`)
        .then(response => {
          this.institution = this.keysToCamelCase(response.data)
          this.activeOwnerSwitch = !!this.institution.ownerId
          this.initializeUsers()
          this.initializeDiets()
        })
        .catch(err => console.log(err))
    },
    initializeBoarders () {
      this.$http.get('/admin/roles/7')
        .then(response => {
          this.boardersToAdd = []
          this.availableBoardersAll = this.keysToCamelCase(response.data)
            .map(boarder => {
              const userName = `${boarder.user.firstName} ${boarder.user.lastName}`
              boarder.fullName = `${boarder.firstName} ${boarder.lastName}`
              boarder.selectInputText = boarder.fullName + ` / ${userName}`
              boarder.userName = userName
              boarder.loggable = boarder.email ? 'Ano' : 'Ne'
              return boarder
            })
          this.availableBoarders = this.availableBoardersAll.filter(user => user.institutionId !== this.institution.id)
          this.boarders = this.availableBoardersAll.filter(user => user.institutionId === this.institution.id)
        })
        .catch(err => console.log(err))
    },
    initializeUsers () {
      this.users = []
      this.usersToAdd = []
      this.availableUsers = []
      this.availableUsersAll = []
      if (this.institution.ownerId) {
        const owner = this.institution.ownerId
        owner.fullName = `${this.institution.ownerId.firstName} ${this.institution.ownerId.lastName}`
        this.owner = owner
      }
      this.$http.get('/admin/roles/6')
        .then(response => {
          this.availableUsersAll = this.keysToCamelCase(response.data)
            .map(user => {
              user.fullName = `${user.firstName} ${user.lastName} - ${user.email}`
              return user
            })
          if (this.institution.ownerId) {
            this.availableUsers = this.availableUsersAll.filter(user => user.id !== this.institution.ownerId.id)
          } else {
            this.availableUsers = this.availableUsersAll.filter(user => user.institutionId !== this.institution.id)
            this.users = this.availableUsersAll.filter(user => user.institutionId === this.institution.id)
          }
          this.initializeBoarders()
        })
        .catch(err => console.log(err))
    },
    initializeDiets () {
      this.$http.get('/admin/diets', { params: { slim: 1 } })
        .then(response => {
          this.availableDiets = this.keysToCamelCase(response.data)
            .filter(diet => diet.dietType === 'Instituční')
            .filter(diet => diet.institutionId !== this.institution.id)
          this.diets = this.keysToCamelCase(response.data)
            .filter(diet => diet.institutionId === this.institution.id)
            .map(diet => {
              diet.foodTypesStr = diet.foodTypes
                .map(type => type.name)
                .join(', ')
              return diet
            })
        })
        .catch(err => console.log(err))
    },
    removeDiet (diet) {
      const requestBody = {
        institutionId: this.institution.id,
        dietId: diet.id,
        set: false
      }
      this.$http.post('/admin/institutions/set/diet', this.keysToSnakeCase(requestBody))
        .then(response => {
          this.initializeDiets()
        })
        .catch(err => console.log(err))
    },
    deleteUser (user) {
      const requestBody = {
        institutionId: this.institution.id,
        users: [{
          [user.id]: null
        }]
      }
      this.$http.post('/admin/institutions/set/boarders', this.keysToSnakeCase(requestBody))
        .then(response => {
          this.initialize()
        })
        .catch(err => console.log(err))
    },
    changeOwner (set) {
      const requestBody = {
        institutionId: this.institution.id,
        ownerId: this.owner ? this.owner.id : null,
        set: set
      }
      this.$http.post('/admin/institutions/set/owner', this.keysToSnakeCase(requestBody))
        .then(response => {
          this.initialize()
        })
        .catch(err => console.log(err))
    },
    addUsers (userObjects = true) {
      const dataSource = userObjects ? this.usersToAdd : this.boardersToAdd
      const users = []
      dataSource.forEach(id => {
        users.push({ [id]: this.institution.id })
      })
      const requestBody = {
        users: users,
        institutionId: this.institution.id
      }
      this.$http.post('/admin/institutions/set/boarders', this.keysToSnakeCase(requestBody))
        .then(response => {
          if (userObjects) {
            this.initializeUsers()
          } else {
            this.initializeBoarders()
          }
        })
        .catch(err => console.log(err))
    },
    addDiets () {
      this.dietsToAdd.forEach(diet => {
        const requestBody = {
          institutionId: this.institution.id,
          dietId: diet.id,
          set: true
        }
        this.$http.post('/admin/institutions/set/diet', this.keysToSnakeCase(requestBody))
          .then(response => {
            const dietIndex = this.dietsToAdd.indexOf(diet)
            this.dietsToAdd.splice(dietIndex, 1)
            this.initializeDiets()
          })
          .catch(err => console.log(err))
      })
    }
  },
  created () {
    this.initialize()
  },
  watch: {
    activeOwnerSwitch () {
      if (!this.activeOwnerSwitch) {
        this.changeOwner(false)
      }
    }
  }
}
</script>

<style scoped>

</style>
